import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { Tooltip } from '@mui/material';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import FeedIcon from '@mui/icons-material/Feed';
import { IconButton } from '@mui/material';
import * as XLSX from 'xlsx';
import CircularProgress from '@mui/material/CircularProgress';
import RefreshIcon from '@mui/icons-material/Refresh';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select'; // Import react-select

const API_URL = 'https://pp-api.off-ease.com/api/AccountHeadApi';


function EngineerWorkReport() {
    const [data, setData] = useState([]);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();
    const [selectedOption, setSelectedOption] = useState('');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [staffId, setStaffId] = useState('');
    const [dataItem, setDataItem] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState('');
    const [staffOptions, setStaffOptions] = useState([]);


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();

    }, [isAuthenticated, companyId, token, logout]);


    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };


    useEffect(() => {
        fetchStaff();
        fetchTableData();
    }, []);

    //FOR GET Customer  Details FROM API
    const fetchStaff = async () => {
        try {
            const response = await fetchData('StaffApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                console.log('Response Data:', response.response_data); // Check actual data structure
                const options = response.response_data.map(staff => ({
                    value: staff.staffId || staff.id, // Use the correct field
                    label: staff.firstName,
                }));
                setStaffOptions(options);
                console.log('Staff Options:', options);
            }
        } catch (error) {
            console.error('Error fetching Staff:', error);
        }
    };


    const handleStaffChange = (selectedOption) => {
        console.log('Selected Option:', selectedOption); // Logs selected option details
        setSelectedStaff(selectedOption);

        // Find the staff option using the selected option's value
        const selectedStaffObject = staffOptions.find(option => option.value === selectedOption.value);

        if (selectedStaffObject) {
            console.log('Selected Staff ID:', selectedStaffObject.value); // Log selected staff value
            setStaffId(selectedStaffObject.value); // Use `value` here instead of `id`
        } else {
            console.log('Staff ID not found');
            setStaffId(''); // Set to empty string if not found
        }
    };

    const fetchTableData = async () => {
        try {
            setLoading(true);

            const response = await fetchData('ReportApi', `/Engineerworkreport/${companyId}/${staffId}/${fromDate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                setDataItem(response.response_data);

            }
            console.log(response);
        } catch (error) {
            console.error('Error fetching Engineer Work Details:', error);
        } finally {
            setLoading(false);

        }
    };

    useEffect(() => {
        fetchTableData();
    }, []);


    const handleFromDateChange = (e) => {
        setFromDate(e.target.value);
    };

    const handleToDateChange = (e) => {
        setToDate(e.target.value);
    };

    //excel

    const handleExportExcel = () => {
        const excelData = [];

        // Add header row
        const headerRow = [
            'Sl.No',
            'Customer',
            'C-Type',
            'Call-Date',
            'Category',
            'Brand',
            'Model',
            'Model Number',
            'WarrantyStatus',
            'Remarks',

        ];
        excelData.push(headerRow);
        // Add data rows
        data.forEach((rowData, index) => {
            const dataRow = [
                index + 1,
                rowData.CustomerName,
                rowData.CustomerType,
                rowData.CalledDate,
                rowData.Category,
                rowData.Brand,
                rowData.ProductModels,
                rowData.Modal,
                rowData.WarrantyStatus,
                rowData.Remarks,


            ];
            excelData.push(dataRow);
        });

        // Create worksheet
        const ws = XLSX.utils.aoa_to_sheet(excelData);

        // Create workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Serviced Call Summary');

        // Save workbook to a file
        XLSX.writeFile(wb, 'CallSummary.xlsx');
    };

    //print
    const handlePrint = () => {
        // Opening a new window
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            alert('Failed to open new window. Please allow pop-ups for this website.');
            return;
        }

        // Styling and HTML setup
        const style = `
            <style>
                body, table { font-family: Times New Roman; font-size: 16px; }
                table { width: 100%; border-collapse: collapse; }
                th, td { border: 1px solid #ddd; padding: 8px; }
                th { background-color: #f3f3f3; font-size: 19px; font-weight: bold; }
                h3 { font-size: 32px; }
            </style>
        `;

        const header = '<html><head><title>Serviced Call Report</title>' + style + '</head><body>';
        const footer = '</body></html>';

        let htmlContent = header;
        htmlContent += '<h3>AMC SUMMARY</h3><table><thead><tr>';
        const headers = ['Sl.No', 'Customer', 'C.Type', 'CalledDate', 'Category', 'Brand', 'Model', 'Model Number', 'Warranty', 'Remarks'];
        headers.forEach(header => htmlContent += `<th>${header}</th>`);
        htmlContent += '</tr></thead><tbody>';

        // Adding rows
        if (Array.isArray(data)) {
            data.forEach((rowData, index) => {
                htmlContent += '<tr>';
                htmlContent += `<td>${index + 1}</td>`;
                htmlContent += `<td>${rowData.CustomerName || ''}</td>`;
                htmlContent += `<td>${rowData.CustomerType || ''}</td>`;
                htmlContent += `<td>${rowData.CalledDate ? new Date(rowData.CalledDate).toLocaleDateString('en-GB') : ''}</td>`;
                htmlContent += `<td>${rowData.Category || ''}</td>`;
                htmlContent += `<td>${rowData.Brand || ''}</td>`;
                htmlContent += `<td>${rowData.ProductModels || ''}</td>`;
                htmlContent += `<td>${rowData.Modal || ''}</td>`;
                htmlContent += `<td>${rowData.WarrantyStatus || ''}</td>`;
                htmlContent += `<td>${rowData.Remarks || ''}</td>`;
                htmlContent += '</tr>';
            });
        }

        htmlContent += '</tbody></table>' + footer;

        // Write to the new window and print
        printWindow.document.write(htmlContent);
        printWindow.document.close();
        printWindow.print();
    };


    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const customStyles = {
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };

    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontWeight: 'bolder' }}>
                        ENGINEER'S WORK REPORT
                    </h6>
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label style={{ display: 'block', color: 'brown', fontSize: '13px', fontWeight: 'bold', marginBottom: '2', textTransform: 'uppercase' }} htmlFor="fromDate">
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label style={{ display: 'block', color: 'brown', fontSize: '13px', fontWeight: 'bold', marginBottom: '2', textTransform: 'uppercase' }} htmlFor="toDate">
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>

                <div style={{ marginLeft: '10px', marginRight: '2', width: '50%', maxWidth: '40%', paddingRight: '2', marginBottom: '2', flexBasis: 'auto' }}>
                    <label style={{ display: 'block', color: 'brown', fontSize: '13px', fontWeight: 'bold', marginBottom: '2', textTransform: 'uppercase' }} htmlFor="party">
                        Engineer
                        <span style={{ color: 'red' }}>*</span>
                    </label>
                    {/* <Select
                        value={selectedStaff}
                        onChange={handleStaffChange}
                        options={staffOptions}
                        placeholder="Select Staff"
                        isSearchable
                    /> */}
                    <Select
                        value={selectedStaff}
                        onChange={handleStaffChange}
                        options={staffOptions}
                        placeholder="Select Staff"
                        isSearchable
                        styles={customStyles}
                        menuPortalTarget={document.body}
                    />
                </div>
                <Button
                    style={{
                        marginRight: '8px',
                        background: 'linear-gradient(to right, red, red)',
                        padding: '10px 20px',
                        color: 'white',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '35px',
                        marginTop: '15px',
                        marginLeft: '10px',
                        width: '15%'
                    }}
                    onClick={fetchTableData}
                    className="linkcolor"
                >
                    <IconButton onClick={fetchTableData}>
                        <RefreshIcon style={{ color: 'white' }} />
                    </IconButton>
                    Refresh
                </Button>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '2px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader sx={{ minWidth: 650 }} aria-label="sticky table" style={{ width: '100%' }}>
                        {/* <TableHead sx={{ backgroundColor: '#1E9694' }}> */}
                        <TableHead sx={{ backgroundColor: '#16325B', Width: '2500px' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#16325B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'white', padding: '3px', textTransform: 'uppercase' }}>S.No</TableCell>
                                <TableCell sx={{ backgroundColor: '#16325B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'white', padding: '3px', textTransform: 'uppercase' }}>Customer</TableCell>
                                <TableCell sx={{ backgroundColor: '#16325B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'white', padding: '3px', textTransform: 'uppercase' }}>Call-Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#16325B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'white', padding: '3px', textTransform: 'uppercase' }}>Description</TableCell>
                                <TableCell sx={{ backgroundColor: '#16325B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'white', padding: '3px', textTransform: 'uppercase' }}>Category</TableCell>
                                <TableCell sx={{ backgroundColor: '#16325B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'white', padding: '3px', textTransform: 'uppercase' }}>Brand</TableCell>
                                <TableCell sx={{ backgroundColor: '#16325B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'white', padding: '3px', textTransform: 'uppercase' }}>Model</TableCell>
                                <TableCell sx={{ backgroundColor: '#16325B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'white', padding: '3px', textTransform: 'uppercase' }}>Model Number</TableCell>
                                <TableCell sx={{ backgroundColor: '#16325B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'white', padding: '3px', textTransform: 'uppercase' }}>Warranty</TableCell>
                                <TableCell sx={{ backgroundColor: '#16325B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'white', padding: '3px', textTransform: 'uppercase' }}>Status</TableCell>
                                <TableCell sx={{ backgroundColor: '#16325B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'white', padding: '3px', textTransform: 'uppercase' }}>Service Remarks</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody sx={{ backgroundColor: '#FFFFFF' }}>
                            {Array.isArray(filteredDataItem) && filteredDataItem.length > 0 ? (
                                filteredDataItem.map((item, index) => (
                                    <TableRow key={index} className="customTableRows">
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{index + 1}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.CustomerName} ({item.CustomerType})</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>
                                            {item.CalledDate && new Date(item.CalledDate).toLocaleDateString('en-GB')}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.ServiceRemarks}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.Category}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.Brand}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.ProductModels}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.Modal}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.WarrantyStatus}</TableCell>
                                        {/* <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '14px', padding: '5px' }}>{item.WorkStatus}</TableCell> */}
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #000000',
                                                fontSize: '14px',
                                                padding: '5px',
                                                backgroundColor: item.WorkStatus === 'Completed' ? 'lightgreen' : 'transparent', // Apply light green when WorkStatus is 'Completed'
                                            }}
                                        >
                                            {item.WorkStatus}
                                        </TableCell>

                                        <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.EngineerRemarks}</TableCell>

                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={13} sx={{ fontSize: '18px' }}>
                                        No data available.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>

                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default EngineerWorkReport;
